import React from 'react';
import {View} from 'react-native';
import {noop} from 'lodash';

import Text from '/component/base/Text';
import TouchableOpacity from '/component/base/TouchableOpacity';
import {CandidateProfile} from '/component/screen/CandidateProfile';
import {CreateCandidateProfile} from '/component/screen/CandidateProfile/CreateCandidateProfile';
import ClientProfile from '/component/screen/ClientProfile';
import CoachProfile from '/component/screen/CoachProfile';
import {ReferralProfile} from '/component/screen/ReferralProfile';
import {
  CANDIDATE_PROFILE,
  CLIENT_PROFILE,
  COACH_PROFILE,
  CREATE_NEW_CANDIDATE,
  REFERRAL_PROFILE,
} from '/enum/recordType.enum';

import {styles} from './RecordScreenRenderer.style';
interface RecordScreenRendererProps {
  onClose: () => void;
  showReportRecordScreen: () => void;
  recordId: string | number | null;
  recordType: string;
  reportName: string;
}

const RECORD_COMPONENT = {
  [CLIENT_PROFILE]: ClientProfile,
  [COACH_PROFILE]: CoachProfile,
  [CANDIDATE_PROFILE]: CandidateProfile,
  [REFERRAL_PROFILE]: ReferralProfile,
  [CREATE_NEW_CANDIDATE]: CreateCandidateProfile,
};

const RecordScreenRenderer: React.FC<RecordScreenRendererProps> = ({
  onClose = noop,
  showReportRecordScreen = noop,
  recordId = null,
  recordType,
  reportName = '',
}) => {
  // @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
  const RecordComponent = RECORD_COMPONENT[recordType];

  if (RecordComponent) {
    return (
      <RecordComponent
        onClose={onClose}
        onShowRecord={showReportRecordScreen}
        recordId={recordId}
        reportName={reportName}
      />
    );
  } else {
    return (
      <View
        style={styles.unknown}
        accessible={true}
        accessibilityLabel={`Unknown Record. Record Type: ${recordType}. Record ID: ${recordId}`}>
        <Text>Unknown Record</Text>
        <Text>[Record Type: {recordType}]</Text>
        <Text>[Record ID: {recordId}]</Text>
        <TouchableOpacity
          onPress={onClose}
          accessible={true}
          accessibilityRole="button"
          accessibilityLabel="Close">
          <Text>Close</Text>
        </TouchableOpacity>
      </View>
    );
  }
};

export default RecordScreenRenderer;
